<template>
  <div class="my-competencies">
    <h3>Мои компетенции проекта</h3>
    <a-row class="my-competencies__grid">
      <template v-for="(item, index) in competenceSetList" :key="index">
        <project-competence-card
          :index="index"
          :competence-set="item"
          @click.stop="handleEdit(index)"
        />
      </template>

      <a-col
        v-if="
          projectStatusId === PROJECT_STATUS_IN_WORK &&
          competenceSetList.length < MAX_COMPETENCE_SET
        "
        :span="8"
        class="empty_card"
        @click="handleAdd"
      >
        <a-row class="avatar">
          <div class="avatar__wrapper">
            <img src="@/assets/icons/IconPlus.svg" alt="" />
          </div>
        </a-row>
        <a-row class="label"> Добавить компетенции </a-row>
      </a-col>
    </a-row>
  </div>

  <c-drawer v-model:open="isShowForm" destroyOnClose>
    <component
      :is="form"
      :competence-set="competenceSet"
      @close="handleCloseForm"
      @update="handleUpdate"
      @subaction="handleDelete"
    />
  </c-drawer>
</template>

<script setup>
  import { onMounted, ref, shallowRef } from 'vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import LeaderMyCompetenceForm from '@/views/leader/projects/agreement/my-competencies/LeaderMyCompetenceForm.vue';
  import LeaderMyCompetenceDelete from '@/views/leader/projects/agreement/my-competencies/LeaderMyCompetenceDelete.vue';
  import CDrawer from '@/components/UI/CDrawer.vue';
  import { MAX_COMPETENCE_SET } from '@/constants/competence-set';
  import ProjectCompetenceCard from '@/components/projects/management/Competencies/ProjectCompetenceCard.vue';
  import { PROJECT_STATUS_IN_WORK } from '@/api/models/ProjectStatus';

  const api = useApi();
  const route = useRoute();
  const emit = defineEmits(['update']);
  const isLoading = ref(true);
  const isShowForm = ref(false);
  const competenceSetList = ref([]);
  const competenceSet = ref(null);
  const form = shallowRef(null);

  const props = defineProps({
    projectStatusId: Number,
  });

  onMounted(async () => {
    await getCompetenceSetList();
    isLoading.value = false;
  });

  const getEmptySet = (index) => ({
    id: null,
    projectId: route.params.id,
    confirmedAt: null,
    rejectedAt: null,
    competenceSubject: null,
    competenceTechnology: null,
    competenceSkill: null,
    index: index,
  });

  const getCompetenceSetList = async () => {
    try {
      const response = await api.projectCompetenceSet.index(
        new URLSearchParams({
          projectId: route.params.id,
        })
      );
      competenceSetList.value = response.sets.items.map((item, index) => ({
        ...item,
        index: index,
      }));
    } catch (error) {
      console.error('error', error);
    }
  };

  const handleAdd = () => {
    if (
      props.projectStatusId !== PROJECT_STATUS_IN_WORK ||
      competenceSetList.value.length >= MAX_COMPETENCE_SET
    )
      return;

    handleShowForm(
      'addCompetenceSet',
      getEmptySet(competenceSetList.value.length)
    );
  };

  const handleEdit = (index) => {
    if (props.projectStatusId !== PROJECT_STATUS_IN_WORK) return;

    const item = competenceSetList.value[index];
    handleShowForm('editCompetenceSet', item);
  };

  const handleDelete = () => {
    isShowForm.value = false;
    handleShowForm('deleteCompetenceSet', competenceSet.value);
  };

  const handleShowForm = (formType, item) => {
    switch (formType) {
      case 'addCompetenceSet':
        competenceSet.value = item;
        form.value = LeaderMyCompetenceForm;
        break;

      case 'editCompetenceSet':
        competenceSet.value = item;
        form.value = LeaderMyCompetenceForm;
        break;

      case 'deleteCompetenceSet':
        form.value = LeaderMyCompetenceDelete;
        break;
    }

    isShowForm.value = true;
  };

  const handleCloseForm = () => {
    competenceSet.value = null;
    form.value = null;
    isShowForm.value = false;
  };

  const handleUpdate = async () => {
    await getCompetenceSetList();
    isLoading.value = false;
    emit('update');
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  * {
    font-family: 'Nunito Sans', sans-serif;
  }

  .my-competencies {
    margin-bottom: 30px;
    max-width: 902px;

    h3 {
      font-size: 18px;
      margin-bottom: 10px;
    }

    &__grid {
      padding: 20px 0;
      column-gap: 20px;
      row-gap: 20px;

      .empty_card {
        align-items: center;
        background-color: $color-bg-primary-white;
        border: 2px dashed $color-input;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 9px;
        min-height: 303px;
        max-width: 210px;
        user-select: none;
        width: 210px;

        .avatar {
          &__wrapper {
            align-items: center;
            background-color: $color-bg-primary-white;
            border: 2px dashed $color-input;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            position: relative;
            height: 80px;
            width: 80px;

            img {
              filter: invert(82%) sepia(2%) saturate(4563%) hue-rotate(197deg)
                brightness(89%) contrast(93%);
              margin: auto;
              height: 21px;
              width: 21px;
            }

            .skeleton {
              width: auto;
            }
          }
        }

        .label {
          color: $color-bg-status-new;
          font-weight: 400;
          font-size: 14px;
          line-height: 19.1px;
          padding: 25px;
        }
      }
    }
  }
</style>
